<template>
  <v-container fluid>
    <div v-if="noDealOwners">
      <v-alert type="info" outlined>Please select at least one Deal Owner</v-alert>
    </div>
    <div v-else>
      <v-row v-if="dealReportOwnerNumberOfCalls" align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <highcharts :options="getChart('Number of calls', dealReportOwnerNumberOfCalls)" />
        </v-col>
      </v-row>
      <v-row v-if="dealReportOwnerNumberOfPitches" align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <highcharts :options="getChart('Number of Pitches', dealReportOwnerNumberOfPitches)" />
        </v-col>
      </v-row>
      <v-row v-if="dealReportOwnerNumberOfWonDeals" align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <highcharts :options="getChart('Number of Won Deals', dealReportOwnerNumberOfWonDeals)" />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import {
  DEAL_REPORT_OWNER_NUMBER_OF_CALLS,
  DEAL_REPORT_OWNER_NUMBER_OF_PITCHES,
  DEAL_REPORT_OWNER_NUMBER_OF_WON_DEALS,
} from "@/graphql/queries/deal";
import DealReportMixin from "@/components/deals/mixins/DealReportMixin";

export default {
  name: "DealCompanyReport",
  mixins: [DealReportMixin],
  props: {
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
    dealOwners: {
      type: Array,
    },
  },
  computed: {
    noDealOwners() {
      return !this.dealOwners || this.dealOwners?.length == 0;
    },
  },
  apollo: {
    dealReportOwnerNumberOfCalls: {
      query: DEAL_REPORT_OWNER_NUMBER_OF_CALLS,
      fetchPolicy: "no-cache",
      variables() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
          dealOwners: this.dealOwners,
        };
      },
      skip() {
        return !this.startDate || !this.endDate || !this.dealOwners || this.dealOwners?.length == 0;
      },
    },
    dealReportOwnerNumberOfPitches: {
      query: DEAL_REPORT_OWNER_NUMBER_OF_PITCHES,
      fetchPolicy: "no-cache",
      variables() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
          dealOwners: this.dealOwners,
        };
      },
      skip() {
        return !this.startDate || !this.endDate || !this.dealOwners || this.dealOwners?.length == 0;
      },
    },
    dealReportOwnerNumberOfWonDeals: {
      query: DEAL_REPORT_OWNER_NUMBER_OF_WON_DEALS,
      fetchPolicy: "no-cache",
      variables() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
          dealOwners: this.dealOwners,
        };
      },
      skip() {
        return !this.startDate || !this.endDate || !this.dealOwners || this.dealOwners?.length == 0;
      },
    },
  },
};
</script>
